import { Component, Input, inject } from '@angular/core';

import { DartsGameScore, DartsMatchType, EventScoreboard, PairScore } from '@frontend/sports/betting-offer/feature/model';
import { SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { Observable, map } from 'rxjs';

@Component({
    template: '',
})
export abstract class DartsScoreboardBaseComponent {
    sitecoreEventDetails = inject(SitecoreEventDetailsConfig);

    @Input() scoreboard: EventScoreboard;

    matchType = DartsMatchType;
    readonly sitecoreEventDetailsVM$: Observable<{ sets: string; legs: string }>;
    constructor() {
        this.sitecoreEventDetailsVM$ = this.sitecoreEventDetails.whenReady.pipe(
            map(() => ({
                sets: this.sitecoreEventDetails.eventDetails.Sets,
                legs: this.sitecoreEventDetails.eventDetails.Legs,
            })),
        );
    }

    get score(): DartsGameScore {
        return this.scoreboard.getScore<DartsGameScore>()!;
    }

    get legs(): PairScore<number> | undefined {
        return {
            participant1: this.score.legs.participant1,
            participant2: this.score.legs.participant2,
        };
    }

    get sets(): PairScore<number> | undefined {
        return {
            participant1: this.score.participant1,
            participant2: this.score.participant2,
        };
    }
}
